import { Link } from "react-router-dom";
import { posts } from "@/mocks/posts";

export default function MemeWall() {
  const memes = posts.filter((post) => post.category === "gengtu");

  return (
    <ul className="grid grid-cols-2 lg:grid-cols-3 gap-3 md:gap-5">
      {memes.map((post, index) => (
        <li key={post.id} className={index === 0 ? "col-span-2 lg:col-span-1 lg:row-span-2" : ""}>
          <Link
            to={`/post/${post.id}`}
            className={`group relative block w-full overflow-hidden rounded-lg bg-foreground-950 cursor-pointer ${
              index === 0 ? "aspect-[16/10] lg:aspect-auto lg:h-full lg:min-h-[420px]" : "aspect-[4/3]"
            }`}
          >
            <img
              src={post.cover}
              alt={`${post.title} - 网爆吃瓜梗图`}
              title={`${post.title} - 网爆吃瓜梗图`}
              className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-[1.05] transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/25 to-transparent"></div>
            <div className="absolute inset-x-0 bottom-0 p-3 md:p-4">
              <h3 className="text-sm md:text-base text-background-50 leading-snug line-clamp-2">{post.title}</h3>
              <span className="mt-2 flex items-center gap-3 text-xs text-background-300">
                <span className="flex items-center gap-1">
                  <span className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-heart-3-line"></i>
                  </span>
                  {post.likes}
                </span>
                <span className="flex items-center gap-1">
                  <span className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-chat-3-line"></i>
                  </span>
                  {post.commentCount}
                </span>
              </span>
            </div>
          </Link>
        </li>
      ))}
    </ul>
  );
}